export function looksLikePlaceholderEmail(value) {
  if (typeof value !== 'string') return false;
  const parts = value.trim().toLowerCase().split('@');
  if (parts.length !== 2 || !parts[0] || !parts[1]) return false;
  const [local, domain] = parts;
  if (/^(?:.+\.)?example\.(?:com|org|net)$/.test(domain) || domain.endsWith('.invalid')) return false;
  const compact = local.replace(/[._+-]/g, '');
  if (/^(?:nolose|sincorreo|noemail|nomail|fake|falso|prueba|test)$/.test(compact) || /^([a-z])\1{3,}$/.test(compact)) return true;
  const keyboardFragment = /(?:asdf|asdj|asjd|sdjf|ksdj|asdk|sakdj|jaklj)/;
  const keyboardLocal = /^[asdfghjkl]+\d*$/.test(compact) && keyboardFragment.test(compact);
  const repeatedKeyboard = /^([sdfghjkl]{2,3})\1+(?:\d+)?$/.test(compact);
  const mixedRepetitions = /^[sdfghjkl]{6,}\d*$/.test(compact) && /([sdfghjkl]{2})\1/.test(compact);
  if (keyboardLocal || repeatedKeyboard || mixedRepetitions || /^(?:qwer(?:ty)?|zxcv(?:bnm?)?)(?:\d+)?$/.test(compact)) return true;
  // Require filler on both sides; unusual nicknames alone are not evidence.
  const fillerDomain = /(?:asdf|sdf|skdf|askdkf|skjdf|kdfks|sadfas|kjkl|ksks|ksjdf|kasdj)/.test(domain.split('.')[0]);
  const fillerLocal = /(?:asdf|sdf|asdj|asjd|ksdj|asdk|sakdj|jaklj)/.test(compact) || /^[bcdfghjklmnpqrstvwxyz]{5,}$/.test(compact);
  return fillerDomain && fillerLocal;
}

export function placeholderEmail(personId, index = 0) {
  const id = Number(personId);
  const suffix = Number.isInteger(id) && id > 0 ? `-${id}` : '';
  return `sin-correo${suffix}${index > 0 ? `-${index + 1}` : ''}@example.com`;
}
